import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { AdditionaAddCoSignerEmailComponent } from './additional-options/additional-add-co-signer-email/additional-add-co-signer-email.component';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {

    @Input() status: any[] = [];
    @Input() industries: any[] = [];
    @Input() statesOfIncorporation: any[] = [];
    @Input() appId: any = 0;
    @Input() currentStep: any = '';
    @Input() nextStep: any = '';
    @Input() nextStepDisabled: any = '';
    @Input() risk: any;
    @Input() app: any;

    @Input() application: any = {};

    @Output() toggleSelectedRow = new EventEmitter<void>();
    @Output() reloadSlice = new EventEmitter<void>();

    @ViewChild(AdditionaAddCoSignerEmailComponent) addCosignerEmail: AdditionaAddCoSignerEmailComponent;

    public showModifyInvoice: boolean = false;
    public showSelectedOffer: boolean = false;
    public showUploadInvoice: boolean = false;
    public showAddGuarantor: boolean = false;
    public showPoDocument: boolean = false;
    public showResendDocs: boolean = false;
    public showOfferList: boolean = false;

    public documents: any[] = [];

    public openBusiness = false;
    public openOwner = false;
    test: any;

    public offers: any = {
        offerList: []
    };
    public selectedOffer: any = {};

    public innerWidth: number = 0;

    constructor(
        private connectionService: ConnectionService,
        private authService: AuthService,
        public router: Router
    ) { }

    ngOnInit() {
        this.innerWidth = window.innerWidth;
        this.openBusiness = false;
        this.openOwner = false;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.innerWidth = window.innerWidth;
    }

    get scrollContainerWidth() {
        if (this.innerWidth < 992) {
            return this.application.applicationProcess.length * 145 + 'px';
        } else {
            return 'auto';
        }
    }

    getOffers(applicationId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                `${environment.gateway}application/${applicationId}/activeOffers/${this.authService.getUserId()}`,
                'application/json', `sp_id=${this.authService.getSalesPersonId()}`).subscribe(
                    (data: any) => {
                        if (data.object) {
                            this.offers = data.object;
                            this.selectedOffer = {};
                            data.object.offerList.forEach((element: any) => {
                                if (element.selected) {
                                    this.selectedOffer = element;
                                }
                            });
                        }
                        resolve(data);
                    },
                    (error: any) => {
                        resolve(error);
                    }
                );
        });
    }

    getDocusignHistory(appId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(`${environment.gateway}app/${appId}/agreement/docusignHistory`,
                'application/json').subscribe(
                    (data: any) => {
                        if (data.object[0]) {
                            this.application.decodeDocusignHistory(data.object[0]);
                        }
                        resolve(undefined);
                    },
                    (error: any) => {
                        resolve(undefined);
                    }
                );
        });
    }

    getActiveOffers(appId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(`${environment.gateway}application/${appId}/activeOffers/${this.authService.getUserId()}`,
                'application/json').subscribe(
                    (data: any) => {
                        resolve(undefined);
                    },
                    (error: any) => {
                        resolve(undefined);
                    }
                );
        });
    }

    getApplication(appId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(`${environment.gateway}v2/appsummary/${appId}`,
                'application/json').subscribe(
                    (data: any) => {
                        this.application.decode(data.object, this.status);
                        resolve(undefined);
                    },
                    (error: any) => {
                        resolve(undefined);
                    }
                );
        });
    }

    onToggleSelectedRow() {
        this.toggleSelectedRow.emit();
    }

    onReloadSlice() {
        this.reloadSlice.emit();
        this.ngOnInit();
    }

    onEmailClick() {
        this.addCosignerEmail.onClick();
    }

    get ownersNames() {
        let ownersNames = '';
        this.app.owners.forEach((owner: any) => {
            ownersNames += ', ' + owner.name;
        });

        return ownersNames.substr(1, ownersNames.length);
    }

    get showCreateSendContracts(): boolean {
        return this.nextStep == 'Create Contracts' && this.application.defaultOfferId;
    }

    get showSubmitInvoice(): boolean {
        return (this.nextStep == 'Submit Invoice' && !this.nextStepDisabled) || this.nextStep == 'Re-Submit Invoice';
    }

    get showContractStatus(): boolean {
        return this.application.processStatus.contractStatusProcess.statusBar.length > 0 || this.application.processStatus.vodStatusProcess.statusBar.length > 0 || this.application.processStatus.dlStatusProcess.statusBar.length > 0;
    }

    get showInvoiceReview(): boolean {
        return this.currentStep == 'Invoice Under Review';
    }

    get showFundingPending(): boolean {
        return this.currentStep == 'Funding Pending';
    }

    get showFunded(): boolean {
        return this.currentStep == 'Funded';
    }

    get showDeclined(): boolean {
        return this.currentStep == 'Declined';
    }

    get showDLDeclined(): boolean {
        return this.currentStep == 'Driver License Declined';
    }

    get showDataError(): boolean {
        return this.currentStep == 'Data Error';
    }

    get showResendBankVerificationLink(): boolean {
        return this.currentStep == 'Preapproval';
    }
}
